<template>
	<section class="app-container">
		<div v-if="indexArticle">
			<editor :article="displayArticle" :isAdmin="isEditor" :editable="false" />
			<spinner v-if="loading" />
		</div>
		<div v-if="!indexArticle && !loading">
			<h3>No landing page found.</h3>
		</div>
	</section>
</template>

<script>
import Editor from '../article/Editor';
import Article from '../../../services/article';
import Spinner from '../../shared/Spinner';
import LinkHighlight from '../../../util/classes/LinkHighlight';
import GridBuilder from '../../../util/classes/GridBuilder';
import { mapGetters } from 'vuex';

export default {
	name: 'Home',
	components: {
		Editor,
		Spinner,
	},
	data: function () {
		return {
			howToArticles: [],
			indexArticle: null,
			article: {},
			articleTypes: [],
			loading: false,
			displayArticle: {},
		};
	},
	computed: {
		...mapGetters(['isEditor']),
	},
	mounted() {
		this.getIndexArticle();
	},
	methods: {
		getIndexArticle: function () {
			this.loading = true;
			Article.instance()
				.getArticlesMinimal('INDEX_PAGE')
				.then((res) => {
					if (!res.data[0]) return;
					let id = res.data[0].id;
					if (id) {
						Article.instance()
							.getArticleById(id)
							.then((res) => {
								this.indexArticle = res.data;
								this.highlightLinks();
								this.generateGrid();
							})
							.catch((error) => {
								console.error(error);
								this.loading = false;
							});
					}
				})
				.catch((error) => {
					console.error(error);
					this.loading = false;
				});
		},
		highlightLinks: function () {
			let linkHighlighter = new LinkHighlight(
				this.indexArticle.html,
				this.indexArticle.articlesMinimal,
				this.indexArticle.id
			);
			this.indexArticle.html = linkHighlighter.getHighlightHtml();
		},
		generateGrid: async function () {
			let gridBuilder = new GridBuilder(this.indexArticle.html);
			let displayHtml = await gridBuilder.getDisplayHtmlAsync();
			this.displayArticle = { ...this.indexArticle, html: displayHtml };
			this.loading = false;
		},
	},
};
</script>

<style scoped>
.landing {
	background-color: var(--bgSecondary);
	height: calc(100vh - 48px);
	overflow: auto;
}
.landing__content {
	position: relative;
	margin-bottom: 3rem;
	padding: 0 0 0 5.9em;
	min-height: 150px;
}
.landing__h1 {
	font-weight: 400;
	color: var(--titlePrimary);
	padding: 0;
}
.landing__h1::before {
	display: none;
}
.landing__h1::after {
	display: none;
}
.landing__heading {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 2rem;
}
.landing__h1-input {
	color: var(--titlePrimary);
}
.landing__p {
	font-weight: 400;
	color: var(--textSecondary);
	margin-bottom: 3rem;
}
.landing__p-textarea {
	display: block;
	font-weight: 400;
	color: var(--textSecondary);
	resize: none;
	width: 100%;
	margin-bottom: 3rem;
}
.landing__overview {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	grid-auto-rows: 150px;
	gap: 24px;
}
.landing__add {
	border: 1.5px solid var(--textAdmin);
	border-radius: 2px;
	background-image: url('../../../assets/icons/blue-plus.svg');
	background-repeat: no-repeat;
	background-position: center;
}
.landing__add:hover {
	cursor: pointer;
	background-color: var(--textAdminHover);
}

.border-dashed {
	border: 2px dashed var(--textAdmin);
	border-radius: 5px;
}
</style>
